export const REFRESH_TOKEN_URL = "/api/v1/auth/refresh-token/reissue";
export const LOGOUT_URL = "/api/v1/auth/logout";

export const ADMIN_ROLES = ["SUPER_ADMIN", "PROJECT_ADMIN", "SUB_ADMIN", "FIELD_ADMIN", "ADMIN"];

/** 토큰 만료 전 선제적 갱신 여유 시간 (초) */
export const TOKEN_REFRESH_BUFFER_SECONDS = 60;

/** 백엔드 인증 에러 코드 */
export const AUTH_ERROR_CODES = {
  ACCESS_TOKEN_EXPIRED: "AUTH_ACCESS_TOKEN_EXPIRED",
  ACCESS_TOKEN_INVALID: "AUTH_ACCESS_TOKEN_INVALID",
  REFRESH_TOKEN_EXPIRED: "AUTH_REFRESH_TOKEN_EXPIRED",
  REFRESH_TOKEN_INVALID: "AUTH_REFRESH_TOKEN_INVALID",
  INVALID_CREDENTIALS: "AUTH_INVALID_CREDENTIALS",
  ACCESS_DENIED: "COMMON_ACCESS_DENIED"
} as const;
